import { QueryParams } from './common';

export enum TableStatus {
  AVAILABLE = 'available',
  OCCUPIED = 'occupied',
  RESERVED = 'reserved',
}

export interface Table {
  id: string;
  restaurantId: string;
  tableNumber: string;
  location?: string;
  capacity?: number;
  qrCode: string;
  status: TableStatus;
  isActive: boolean;
  activeOrdersCount?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTableDto {
  tableNumber: string;
  location?: string;
  capacity?: number;
}

export interface UpdateTableDto {
  tableNumber?: string;
  location?: string;
  capacity?: number;
  status?: TableStatus;
  isActive?: boolean;
}

export interface TableQueryParams extends QueryParams {
  status?: TableStatus;
  isActive?: boolean;
}
